/* export const dateSorter = (a, b) => {
    const dateA = new Date(a.goTrashDate.replace(/(\d{4})\/(\d{2})\/(\d{2})/, '$2/$3/$1'));
    const dateB = new Date(b.goTrashDate.replace(/(\d{4})\/(\d{2})\/(\d{2})/, '$2/$3/$1'));
  
    return dateA.getTime() - dateB.getTime();
  }; */
  export function dateSorter(date1, date2) {
    const parsedDate1 = new Date(date1.goTrashDate);
    const parsedDate2 = new Date(date2.goTrashDate);
  
    if (parsedDate1 < parsedDate2) {
      return -1;
    } else if (parsedDate1 > parsedDate2) {
      return 1;
    } else {
      return 0;
    }
  }
  export function convertDateString(dateString) {
    const date = new Date(dateString);
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    const formattedDate = `${year}/${month}/${day}`;
    return formattedDate;
  }
  